var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.link ? _vm.link.tag : 'div', _vm._b({
    tag: "component",
    staticClass: "gg-banner",
    style: {
      backgroundColor: _vm.backgroundColor
    }
  }, 'component', _vm.link ? _vm.link.tag === 'GGLink' ? {
    to: _vm.link.value
  } : {
    href: _vm.link.value
  } : {}, false), [_c('div', {
    staticClass: "gg-banner__desktop"
  }, [_vm.desktopBanner ? [_vm.desktopBanner.includes('.mp4') || _vm.desktopBanner.includes('.webm') ? _c('video', {
    staticClass: "gg-banner__desktop-el",
    style: {
      maxHeight: _vm.desktopMaxHeight
    },
    attrs: {
      "src": _vm.desktopBanner,
      "loop": "",
      "muted": "",
      "autoplay": ""
    },
    domProps: {
      "muted": true
    }
  }) : _c('img', {
    staticClass: "gg-banner__desktop-el",
    style: {
      maxHeight: _vm.desktopMaxHeight
    },
    attrs: {
      "src": _vm.desktopBanner
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "gg-banner__mobile"
  }, [_vm.mobileBanner ? [_vm.mobileBanner.includes('.mp4') || _vm.mobileBanner.includes('.webm') ? _c('video', {
    staticClass: "gg-banner__mobile-el",
    style: {
      maxHeight: _vm.mobileMaxHeight
    },
    attrs: {
      "src": _vm.mobileBanner,
      "loop": "",
      "muted": "",
      "autoplay": ""
    },
    domProps: {
      "muted": true
    }
  }) : _c('img', {
    staticClass: "gg-banner__mobile-el",
    style: {
      maxHeight: _vm.mobileMaxHeight
    },
    attrs: {
      "src": _vm.mobileBanner
    }
  })] : _vm._e()], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }